(function () {
    'use strict';

    angular
        .module('virtualFairs')
        .controller('PhysicalFairSettingsController', PhysicalFairSettingsController)

    PhysicalFairSettingsController.$inject = ['$uibModal', 'ExpoService', 'expos'];


    function PhysicalFairSettingsController($uibModal, ExpoService, expos) {
        var vm = this;

        vm.queryFlag                    = false;
        vm.expos                        = [];
        vm.expotypes                    = [];
        vm.selectExpos                  = selectExpos;
        vm.getByFilter                  = getByFilter;
        vm.createExpo                   = createExpo;
        vm.sendEmailTest                = sendEmailTest;
        vm.deletePhysicalFair           = deletePhysicalFair;
        vm.physicalFairSettingsStatus   = physicalFairSettingsStatus;

        /* PAGINATION */
        vm.pageChanged  = pageChanged;
        vm.setPage      = setPage;
        vm.page         = 1;
        
        function activate() {
            vm.setPage(1);
            vm.expos = expos;
            vm.expos.unshift({id: -1, name: '--- All ---'});
            vm.selectExpos();
            // vm.getByFilter();

            // Prepare expos select
            // vm.exposSelect = [];
            // angular.copy(expos, vm.exposSelect);
            // vm.exposSelect.unshift({id: -1, name: '--- All ---'});
            // vm.expoSelected                 = -1;
        }

        function setPage(page) {
            vm.currentPage = page;
        }

        function pageChanged(page) {
            vm.page = vm.currentPage;
            vm.getByFilter(false);
        }

        function selectExpos () {
            ExpoService.getExpos().then(function(response){
                vm.expos = response.data;
                vm.expos.unshift({id: -1, name: '--- All ---'});
            });
        }

        function getByFilter () {
            vm.queryFlag = false;
            let query = {};
            query['page'] = vm.page;
            query['list'] = 1;
            if(vm.expoSelected > 0) {
                query['physical_fair_id'] = vm.expoSelected;
            }
            ExpoService.getExposBySettings(query).then(function(response){
                vm.queryFlag = true;
                vm.list = response.data.data;
                vm.totalItems = response.data.total;
                vm.itemsPerPage = response.data.per_page;
                vm.to = response.data.to;
                vm.setPage(response.data.current_page);
            });
        }

        function createExpo(virtualfair = null) {
            $uibModal.open({
                templateUrl: "templates/virtualfairs/settings/form/form.modal.html",
                controller: "VirtualFairSettingsFormController",
                controllerAs: "vm",
                resolve: {
                    virtualfair: () => {
                        return virtualfair;
                    },
                    expotypes: () => {
                        return vm.expotypes;
                    }
                },
            });
        }

        function sendEmailTest (virtualfair) {
            alertify.prompt('Email confirmation test', 'Who do you want to send this email to?', null,
                function(evt, value ){
                    if(value && value.length){
                        let data = {
                            id: virtualfair.id,
                            email: value
                        }
                    
                        ExpoService.sendEmailTest(data)
                        .then(function (response) {
                            if(!response.data.error) {
                                alertify.success('Email confirmation test sended!');
                            } else {
                                alertify.error(response.data.msg);
                            }
                        });
                    }
                },
                function(){
                    return true;
                });
        }

        function deletePhysicalFair (virtualfair) {
            if(virtualfair.pre_registrations.length == 0) {
                alertify.confirm(
                    'Delete Virtual Fair',
                    `Do you really want to delete this <strong>${virtualfair.name}</strong>?`,
                    function () {
                        VirtualFairService.deleteVirtualFair(virtualfair.id)
                            .then(function (response) {
                                if(!response.data.error) {
                                    vm.setPage(1);
                                    vm.getByFilter();
                                    alertify.success('Virtual event successfull deleted!');
                                } else {
                                    alertify.error(response.data.msg);
                                }
                            });
                    },
                    function () {
                        return true;
                    }
                );
            }
        }

        function physicalFairSettingsStatus (expo) {
            alertify.confirm(
                'Open/Close Physical Event',
                'Would you like to <strong>' + (expo.show_to_customers == 0 ? 'OPEN' : 'CLOSE') + '</strong> this Physical Event for registration of exhibitors?',
                function () {
                    ExpoService.physicalFairSettingsStatus(expo.id)
                        .then(function (response) {
                            if(!response.data.error) {
                                expo.show_to_customers = response.data.status;
                                alertify.success('Physical event successfull updated!');
                            } else {
                                alertify.error(response.data.msg);
                            }
                        });
                },
                function () {
                    return true;
                }
            );
        }

        activate();
    }

})();